const SearchIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={20}
    height={20}
    {...props}
  >
    <title>{"icon_search"}</title>
    <defs>
      <path
        id="a"
        d="M8.5 0a8.5 8.5 0 0 1 6.677 13.761l4.53 4.532a1 1 0 0 1-1.414 1.414l-4.532-4.53A8.5 8.5 0 1 1 8.5 0Zm0 2a6.5 6.5 0 1 0 4.548 11.144l.045-.051c.016-.016.033-.032.05-.046A6.5 6.5 0 0 0 8.5 2Z"
      />
    </defs>
    <use xlinkHref="#a" fill="#393c41" fillRule="nonzero" />
  </svg>
);
export default SearchIcon;
